module.exports = __webpack_public_path__ + "img/icon_per_hk.260be28b.png";